import { sortingTypesEnum } from '../enums/sorting-types.enum';

const sorterAny = () => 0;

// Sorting function for sorting games by release date
const sorterNewest = (a, b) => {
    if (!a.gameReleaseDate && !b.gameReleaseDate) {
        return 0;
    }

    if (a.gameReleaseDate && !b.gameReleaseDate) {
        return -1;
    }

    if (!a.gameReleaseDate && b.gameReleaseDate) {
        return 1;
    }

    try {
        const dateA = new Date(a.gameReleaseDate);
        const dateB = new Date(b.gameReleaseDate);

        return ((dateA > dateB) && 1)
            || ((dateA < dateB) && -1)
            || 0;

    } catch (e) {
        console.error('Failed to parse game release date', e);

        return 0;
    }
};

const sorterAlphabeticAsc = (a, b) => {
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
};

const sorterAlphabeticDesc = (a, b) => {
    return sorterAlphabeticAsc(a, b) * -1;
};

export const sortersMapping = {
    [sortingTypesEnum.ANY]: sorterAny,
    [sortingTypesEnum.NEWEST]: sorterNewest,
    [sortingTypesEnum.ALPHABETIC_ASC]: sorterAlphabeticAsc,
    [sortingTypesEnum.ALPHABETIC_DESC]: sorterAlphabeticDesc,
};
